/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedStarterPacks.defs.js'
export { main as default } from './getSuggestedStarterPacks.defs.js'
